module.exports = __webpack_public_path__ + "assets/img/conversation.bdb6ea4e.png";